import { useTheme } from '../../../contexts/ThemeContext';

export default function Footer() {
  const { isDark } = useTheme();

  return (
    <footer
      className="py-20 px-8 lg:px-12 transition-colors duration-300"
      style={{ background: isDark ? '#070a0f' : '#0a0a0a' }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img
              src="https://public.readdy.ai/ai/img_res/1ffdb13e-c23c-4f92-af81-610280b8a7d6.png"
              alt="Fortixa"
              className="object-contain mb-6"
              style={{ width: '90px', height: '90px' }}
            />
            <p
              className="text-sm font-semibold text-white/50 tracking-wide mb-4 uppercase"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              AI Systems for Modern Businesses
            </p>
            <p
              className="text-white/40 leading-relaxed max-w-sm text-sm"
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}
            >
              Fortixa helps organizations deploy practical AI systems that streamline operations, automate customer engagement, and unlock new levels of efficiency.
            </p>
          </div>

          {/* Navigation Column */}
          <div>
            <h4
              className="text-xs font-bold mb-6 tracking-[0.2em] uppercase text-white/50"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Navigation
            </h4>
            <ul className="space-y-4">
              {[
                { label: 'Home', href: '#' },
                { label: 'Services', href: '#services' },
                { label: 'Industries', href: '#industries' },
                { label: 'How It Works', href: '#how-it-works' },
                { label: 'Contact', href: '#contact' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4
              className="text-xs font-bold mb-6 tracking-[0.2em] uppercase text-white/50"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Get Started
            </h4>
            <p
              className="text-white/40 text-sm mb-6 leading-relaxed"
              style={{ fontFamily: 'Montserrat, sans-serif', fontWeight: 400 }}
            >
              Ready to strengthen your business with AI?
            </p>
            <a
              href="#contact"
              className="inline-block px-6 py-3 bg-[#2563EB] text-white text-sm font-semibold rounded-full hover:bg-[#1d4ed8] transition-all cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p
              className="text-white/30 text-xs"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              © 2025 Fortixa. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a
                href="#"
                className="text-white/30 hover:text-white/60 transition-colors cursor-pointer text-xs"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-white/30 hover:text-white/60 transition-colors cursor-pointer text-xs"
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
